import axiosInstance from "../../shared/api/axiosInstance";

export const login = (data) => {
    return axiosInstance.post("/site/auth/login", data)
}

export const completeReg = (data) => {
    return axiosInstance.post("/site/auth/register/complete", data)
}

export const register = (data) => {
    return axiosInstance.post("/site/auth/register", data)
}

export const restorePassword = (email) => {
    return axiosInstance.post("/site/auth/password/reset", {email})
}